/* eslint-disable arrow-body-style */
import * as React from "react";
import {Component} from "react";

import {observer} from "mobx-react";

import "./project-status-toggle.scss";

import {Checkbox, Popup} from "semantic-ui-react";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";

export interface ProjectStatusToggleProps {
    auftragsverwaltung: Auftragsverwaltung;
}

@observer
export class ProjectStatusToggle extends Component<ProjectStatusToggleProps, any> {

    constructor(props: ProjectStatusToggleProps) {
        super(props);
        this.state = {
            value: this.props.auftragsverwaltung.ProjectStore?.hideClosedProjects
        };

        this.handleToggleChange = this.handleToggleChange.bind(this);
    }

    render(): React.ReactElement | null {
        const {value} = this.state;

        return (
            <Popup content="Abgeschlossene Projekte ausblenden"
			       trigger={
				       <Checkbox toggle className="project-status-toggle"
                        label="Geschlossene ausblenden"
                        onChange={(e, data) => {
                            this.handleToggleChange(data.checked);
                        }}
                        checked={value}/>
			       } />
        );
    };

    handleToggleChange(checked: boolean | undefined): void {
        const {auftragsverwaltung} = this.props;

        auftragsverwaltung.ProjectStore.hideClosedProjects = !!checked;

        this.setState({
            value: checked
        });
    };

}
